export const consentChoiceValue = {
  doNotConsent: 0,
  consent: 1,
};
